export default `float de(vec3 p){
    float radius = 1.;
    float height = 3.;
    vec2 q = vec2(length(p.xz), p.y);
    vec2 tip = q - vec2(0.0, height);
    vec2 mantleDir = normalize(vec2(height, radius));
    float mantle = dot(tip, mantleDir);
    float d = max(mantle, -q.y);
    float projected = dot(tip, vec2(mantleDir.y, -mantleDir.x));

    
    if ((q.y > height) && (projected < 0)) {
      d = max(d, length(tip));
    }

    
    if ((q.x > radius) && (projected > length(vec2(height, radius)))) {
      d = max(d, length(q - vec2(radius, 0.0)));
    }
    return d;
  }`